<!--
 * @Description: Jeson Create File
 * @Version: 1.0
 * @Autor: Jeson
 * @Date: 2021-11-16 14:28:45
 * @LastEditors: Jeson
 * @LastEditTime: 2022-01-21 14:04:43
-->
<template>
  <div id="iStorey">
    <div
      v-for="(storey, index) in storeyList"
      :key="index"
      class="storeylist"
    >
      <div>
        <StoreyItemsTemplate
          :ref="`${storey.StoreyId}`"
          :storey="storey"
          :index="index"
          :length="storeyList.length"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StoreyItemsTemplate from './StoreyItemsTemplate'

import { BaseMixin } from '@/mixins/BaseMixin'

export default {
  name: 'Storey',
  components: {
    StoreyItemsTemplate
  },
  mixins: [BaseMixin],
  data() {
    return {
      storeyList: [],
      loading: true,
      scrollParams: [],
      search: {
        Offset: 1
      },
      timer: null,
      IsHasNext: false
    }
  },
  destroyed() {},
  mounted() {

  },
  created() {

  },
  methods: {
    scrollTo(v) {
      document.documentElement.scrollTop = Number(
        this.$refs[`${v.Id}`][0].$el.offsetTop - 100
      )
    },
    async getStory() {
      this.$hys.openLoading()
      const res = await this.postAction('/api_basedata/ActiveBase/GetStoreysV2', {
        'PageSize': 20,
        'PageIndex': 1,
        'AppOrPcType': 1

      })
      if (res.IsSuccess) {
        res.Data.floorList.map(oo => {
          this.storeyList.push(oo)
        })

        this.IsHasNext = res.Count > this.storeyList.length
        if (this.IsHasNext) {
          this.search.Offset = this.search.Offset + 1
        }
      }
      this.$hys.clearLoading()
    },
    init() {
      this.getStory()
    }

  }
}
</script>

<style lang="less" scoped>
#iStorey {
  display: flex;
  justify-content: space-between;
  margin-left: calc((100vw - 1200px) / 2);
  width: 1200px;
  max-width: 1200px;
  flex-direction: row;
  flex-wrap: wrap;

  .storeylist {
    margin-top: 20px;
    width: 100%;
  }

  .storeylist:last-child {
    margin-bottom: 20px;
  }
}
</style>
